import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { RestaurantService } from 'src/app/core';

/**
 * UM formatador para o app inteiro. `toLocaleString(locale, opções)` monta um
 * `Intl.NumberFormat` novo a cada chamada, e o pipe roda em cada preço de cada card: no
 * perfil do boot do cardápio pesado (519 cards, CPU 4x) o `commaDecimal` era a função mais
 * cara do app, 74 ms. A saída é a mesma por especificação (`toLocaleString` é definido como
 * `new Intl.NumberFormat(locale, opções).format`) — o spec confere byte a byte.
 */
const REAL = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

@Pipe({ name: 'multiCurrency' })

export class MultiCurrencyPipe implements PipeTransform {

    constructor(private restaurantService: RestaurantService, private currencyPipe: CurrencyPipe) { }

    currency: string = this.restaurantService.restaurant ? (this.restaurantService.restaurant.info.currency || "BRL") : "BRL"

    transform(value: number) {

        value = Number(value);

        if (!value && typeof (value) !== 'number') return value;

        if (this.currency == "BRL") {
            return this.commaDecimal(Number(value));

        } else if (this.currency == "PYG") {
            let roundValue = Math.round(value);
            return "₲ " + this.numberWithDotsInThousandUnit(roundValue);

        } else if (this.currency == "ARS") {
            let roundValue = Math.round(value);
            return "$ " + this.numberWithDotsInThousandUnit(roundValue);

        } else if (this.currency == 'USD') {
            return "$ " + Number(value).toFixed(2);

        } else if (this.currency == 'EUR') {
            return Number(value).toFixed(2) + " €";

        } else if (this.currency == 'MZN') {
            return this.numberWithDotsInThousandUnit(value) + " MT";
            
        } else if (this.currency == 'BOB') {
            return Number(value).toFixed(2) + " Bs";
        }
        
    }

    commaDecimal(value) {
        value = Math.round((value).toFixed(3) * 100 ) / 100;

        return REAL.format(value);
    }

    numberWithDotsInThousandUnit(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
}